import axios from "axios";
import { getAuthToken } from "core/helper/localstorage";
import { handleUnauthorized } from "./unauthorized";

const getAxiosInstance = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_API_URL_V2
  };
  let instance = axios.create(defaultOptions);

  instance.interceptors.request.use(
    async (config) => {
      const token = getAuthToken();
      config.headers.Authorization = token ? `Bearer ${token}` : "";
      return config;
    },
    (err) => {
      Promise.reject(err);
    }
  );

  instance.interceptors.response.use(
    (response) => response,
    (err) => {
      handleUnauthorized(err);
      return Promise.reject(err);
    }
  );

  return instance;
};

export default getAxiosInstance();
